import Courses from '../../data/courses'


const state = {
	courses : Courses.courses
}


const getters = {
	specialcourses: state =>{
		return state.courses.filter((course) => {
			if (course.special == 1)
                return course
		});
	},
	normalcourses: state =>{
		return state.courses.filter((course) => {
			if (course.special == 0)
                return course
		});
	}
}


const mutations = {
};


const actions = {
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}